import { useEffect, useState } from "react";
import Select from "react-select";
import { Col, Row, Dropdown, Modal, Table, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMessage,
  faPhone,
  faEllipsisVertical,
  faTimes,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FaWhatsapp } from "react-icons/fa";
import useLocalStorageState from "use-local-storage-state";
import { useLocation, useSearchParams } from "react-router-dom";

import {
  GetRequest,
  PutRequest,
  PostRequest,
  DeleteRequest,
} from "../../../Utils/hooks/ApiHandler.jsx";
import { getCountries } from "../../../Utils/hooks/location.jsx";
import { toast } from "sonner";
import DeleteModal from "../../DeleteModal.jsx";
import { DetailsSkeleton } from "../../../Utils/skeletonLoader/DetailsSkeleton.jsx";
import { WhatsappModal } from "../../../CommonComponents/WhatsappModal.jsx";
import ReactQuill from "react-quill";
import TwilioIntegrationForm from "../../ivr/TwilioIntegrationForm.jsx";
import GlobalCallModal from "../../ivr/GlobalCallModal.jsx";
import {
  checkTwilioIntegration,
  fetchTemporaryFilterData,
  navigateBackFromCrmDetail,
  navigateToCrmDetail,
} from "../../../Utils/helpers/commonhelper.js";
import DyanmicCallLog from "../../ivr/DynamicCallLog.jsx";
import { ContactForm } from "../../Contacts/ContactModule/ContactForm.jsx";
import { LeftSideCompanyDetails } from "./CompanyDetailsModules/LeftSideModules/LeftSideCompanyDetails.jsx";
import { RightSideCompanyDetails } from "./CompanyDetailsModules/RightSideModules/RightSideCompanyDetails.jsx";
import { useGetEssentials } from "../../../Utils/hooks/useGetEssentials.jsx";
import { AuthorizationCard } from "../../../CommonComponents/AuthorizationCard";
import { useGlobalState } from "../../../Utils/hooks/useFilterQueryValue";

export const CompanyDetails = () => {

  // Session storage and authentication setup
  const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()
  // rbac permission object 
  const [PERMISSION, _] = useLocalStorageState('permission');

  const [companyFilterDataParams] = useGlobalState('companyFilterDataParams', { currAdvFilter: null, applyFilterData: {} })
  const currAdvFilter = companyFilterDataParams?.currAdvFilter

  // Add these to your existing state declarations
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [globalDiller, setGlobalDiller] = useState(false);
  const [showtwilioModal, setShowTwilioModal] = useState(false);
  const [callLogOpen, setCallLogOpen] = useState(false);
  const [showContactCanvas, setContactCanvas] = useState(false);
  const [noteToDelete, setNoteToDelete] = useState(null);
  const [expandedNoteId, setExpandedNoteId] = useState(null);
  const [activeTab, setActiveTab] = useState("Communications"); // Track active tab
  const [expanded, setExpanded] = useState(false);
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [isCloneClicked, setIsCloneClicked] = useState(false);
  const [contactDetails, setContactDetails] = useState({});

  // parsed data states
  const [parsedUserPhone, setParsedUserPhone] = useState([]);
  const [parsedUserEmail, setParsedUserEmail] = useState([]);
  const [parsedTimezone, setParsedTimezone] = useState({});
  const [isCheckingTwilio, setIsCheckingTwilio] = useState(false);
  const [integrationStatus, setIntegrationStatus] = useState({
    whatsapp: "not_checked", // 'not_checked', 'success', 'fail'
    sms: "not_checked",
    email: "not_checked",
  });

  // Add these to your existing state declarations
  const [showMessageModal, setShowMessageModal] = useState({
    whatsapp: false,
    sms: false,
    email: false,
  });
  const [messageData, setMessageData] = useState({
    subject: "",
    body: "",
    file: null,
    notes: "",
  });

  const [selectedContactId, setSelectedContactId] = useState(null);

  const [whatsappKey, setWhatsappKey] = useState(null);
  const [smsKey, setSmsKey] = useState(null);
  const [apiLoading, setApiLoading] = useState({
    whatsapp: false,
    sms: false,
    email: false,
  });
  const [apiError, setApiError] = useState({
    whatsapp: null,
    sms: null,
    email: null,
  });
  const [whatsappModalOpen, setWhatsAppModalOpen] = useState(false);
  const [notes, setNotes] = useState([]);
  const [notesContent, setNotesContent] = useState("");
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [isNotesLoading, setIsNotesLoading] = useState(false);
  const [notesError, setNotesError] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [shows, setShows] = useState(false);
  const [targets, setTargets] = useState(null);

  const [companyLeads, setCompanyLeads] = useState([]);

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("currCompanyId");
  const companyIds = location?.state?.companyIds || [];
  const currentCompanyIndex = companyIds.findIndex(
    (idFromList) => String(idFromList) === String(companyId)
  );
  const prevCompanyId = currentCompanyIndex > 0
    ? companyIds[currentCompanyIndex - 1]
    : null;
  const nextCompanyId =
    currentCompanyIndex >= 0 && currentCompanyIndex < companyIds.length - 1
      ? companyIds[currentCompanyIndex + 1]
      : null;

  const [country, setCountries] = useState([{ countryName: "", countryId: 0 }])
  // Email module specific state
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailRecipients, setEmailRecipients] = useState([]);
  const [currentEmailInput, setCurrentEmailInput] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [emailSending, setEmailSending] = useState(false);
  const [documents, setDocuments] = useState([])
  const [documentToDelete, setDocumentToDelete] = useState(null)
  const [deleteDocument, setDeleteDocument] = useState(false)

  const [showIntegrationModal, setShowIntegrationModal] = useState({
    whatsapp: false,
    sms: false,
    email: false,
  });

  const [integrationError, setIntegrationError] = useState({
    whatsapp: null,
    sms: null,
    email: null,
  });
  const [smtpDetails, setSmtpDetails] = useState(null);
  const [integrationLoading, setIntegrationLoading] = useState(false);


  const nextCompany = () => {
    if (!nextCompanyId) return;
    navigateToCrmDetail(
      navigate,
      location,
      `/companyDetails?currCompanyId=${nextCompanyId}`,
      { companyIds },
    );
  };

  const previousCompany = () => {
    if (!prevCompanyId) return;
    navigateToCrmDetail(
      navigate,
      location,
      `/companyDetails?currCompanyId=${prevCompanyId}`,
      { companyIds },
    );
  };

  const handleCloseCompanyDetails = () => {
    navigateBackFromCrmDetail(navigate, location, "/company", {
      beforeNavigate: () => {
        if (currAdvFilter === "apply") {
          fetchTemporaryFilterData(companyFilterDataParams?.applyFilterData)
        }
      },
    });
  };

  // rbac permissions
  // permission setup for masters
  const masterGrant = PERMISSION?.setting?.feature?.master;
  // permission setup for company
  const companyGrants = PERMISSION?.company;
  const companyDocGrant = companyGrants?.feature.document;
  const companyActivityGrant = companyGrants?.feature.activity;

  // contact permissions
  const contactGrants = PERMISSION?.contact;

  // Fetch countries when component mounts
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await getCountries()
        if (data) {
          setCountries(
            data.map((c) => ({
              countryName: c.name,
              countryId: c.id,
            })),
          )
        }
      } catch (err) {
        return
      }
    }
    fetchCountries()
  }, [])

  const handleReassingCancel = () => {
    setShowReassignModal(false);
    setSelectedUser(null);
  };

  const handleCloneClicked = () => {
    setShowOffcanvas(true);
    setIsCloneClicked(true);
  };

  const handleDeleteCompany = async (id) => {
    setLoading(true)
    try {
      const res = await DeleteRequest(
        `company/deleteCompany/${id}/${customer?.customer_details?.customer_id}/${customer?.customer_details?.id}`,
        { headers },
        extras
      );

      setConfirmDeleteId(null);

      if (res?.success === false || res?.status === "fail") {
        setLoading(false)
        toast.warning(res?.message || "Company associated to contact")
        return
      }
      setLoading(false)
      toast.success(res.message || "Deleted successfully")
      navigate("/company")
    } catch (err) {
      setConfirmDeleteId(null);
      setLoading(false)
      toast.error(err.message || "Delete error");
    }
  };

  const handleMessageInputChange = (e) => {
    const { name, value } = e.target;
    setMessageData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setMessageData((prev) => ({
      ...prev,
      file: e.target.files[0],
    }));
  };

  const handleBodyChange = (content, delta, source, editor) => {

    setMessageData((prev) => ({
      ...prev,
      body: content,
    }));
  };


  const handleSendMessage = async (type) => {
    // Implement your API call to send the message based on type (whatsapp/sms/email)
    // You can use messageData.subject, messageData.body, messageData.file, messageData.notes
    try {
      const formData = new FormData();
      formData.append("subject", messageData.subject);
      formData.append("body", messageData.body);
      formData.append("notes", messageData.notes);
      if (messageData.file) {
        formData.append("file", messageData.file);
      }
      formData.append("company_id", companyId);
      formData.append("customer_id", customerId);

      const payload = {
        subject: messageData.subject,
        body: messageData.body,
        notes: messageData.notes !== "" ? messageData.notes : "",
        file: messageData.file,
        customer_id: customer.customer_details?.customer_id,
        to_id: companyId,
        module_name: "company",
        user_login_id: customer.customer_details?.id,
      };
      let endpoint = "";
      if (type === "whatsapp") {
        endpoint = "whatsapp/sendMessage";
      } else if (type === "sms") {
        endpoint = "sms/sendMessage";
      } else if (type === "email") {
        endpoint = "common/sendMail";
      }
      const response = await PostRequest(
        endpoint,
        payload,
        true, // Set to true if sending files
        { headers },
        extras
      );
      if (response.status === "success") {
        toast.success(`Message sent successfully via ${type}`);
        setShowMessageModal((prev) => ({ ...prev, [type]: false }));
        setMessageData({
          subject: "",
          body: "",
          file: null,
          notes: "",
        });
      } else {
        toast.error(response.message || `Failed to send ${type} message`);
      }
    } catch (error) {
      toast.error(error.message || `Error sending ${type} message`);
    }
  };

  // Fetch email templates
  const fetchTemplates = async () => {
    setTemplatesLoading(true);
    try {
      const response = await GetRequest(
        `common/fetchEmailTemplates`,
        { headers },
        extras
      );

      if (response.status === "success" && response.data) {
        setTemplates(response.data);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setTemplatesLoading(false);
    }
  };

  // Handle template selection
  const handleTemplateSelect = async (templateId, templateName) => {
    if (!templateId) {
      setSelectedTemplate("");
      return;
    }

    setSelectedTemplate(templateName);

    try {
      const response = await GetRequest(
        `common/getEmailTemplate/${templateId}/${templateId}`,
        { headers },
        extras
      );

      if (response.status === "success" && response.data) {
        setMessageData((prev) => ({
          ...prev,
          subject: response.data.subject || "",
          body: response.data.body || "",
        }));
      }
    } catch (error) {
      toast.error("Error loading template");
    }
  };
  const handleEmailInputKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addEmailTag();
    }
  };

  const addEmailTag = () => {
    const email = currentEmailInput.trim();
    if (email && isValidEmail(email) && !emailRecipients.includes(email)) {
      setEmailRecipients((prev) => [...prev, email]);
      setCurrentEmailInput("");
    } else if (!isValidEmail(email)) {
      toast.error("Please enter a valid email address");
    }
  };
  const removeEmailTag = (emailToRemove) => {
    setEmailRecipients((prev) =>
      prev.filter((email) => email !== emailToRemove)
    );
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSendEmail = async () => {
    if (emailRecipients.length === 0) {
      toast.error("Please add at least one email recipient");
      return;
    }

    if (!messageData.subject.trim()) {
      toast.error("Please enter email subject");
      return;
    }

    if (!messageData.body.trim()) {
      toast.error("Please enter email body");
      return;
    }
    setEmailSending(true);

    try {
      const payload = {
        customer_id: customerId,
        to_id: companyId,
        user_email: emailRecipients,
        subject: messageData.subject,
        body: messageData.body,
        module_name: "company",
        user_login_id: customer?.customer_details?.id,
      };

      const response = await PostRequest(
        "common/sendMail",
        payload,
        true, // For file upload
        { headers },
        extras
      );
      if (response.status === "success") {
        toast.success("Email sent successfully");
        handleCloseEmailModal();
      } else {
        toast.error(response.message || "Failed to send email");
      }
    } catch (error) {
      toast.error(error.message || "Error sending email");
    } finally {
      setEmailSending(false);
    }
  };

  const handleCloseEmailModal = () => {
    setMessageData({
      subject: "",
      body: "",
      file: null,
      notes: "",
    });
    setEmailRecipients([]);
    setCurrentEmailInput("");
    setSelectedTemplate("");
    setShowEmailModal(false);
  };

  const handleIntegrationModalClose = () => {
    setShowIntegrationModal(false);
  };

  const fetchCompanyDetails = async () => {
    // setOnclickedLead(false);

    // setLeads([]);
    if (!customerId) return;

    setLoading(true);
    setError(null);

    try {
      const res = await GetRequest(
        `company/CompanyDetails/${customerId}/${companyId}/${customer?.customer_details?.id}`,
        { headers },
        extras
      );
      if (res.data) {
        console.log('res from detail page', res.data)
        setCompanyData(res.data);
        setContactDetails(res.data);
        // setLeads([]);
        setCompanyLeads(res.data);
        const parsedPhoneData = res.data[0]?.user_phone
          ? JSON.parse(res.data[0]?.user_phone)
          : null;
        parsedPhoneData && setParsedUserPhone(parsedPhoneData);
        // parsed for email
        const parsedEmailData = res.data[0]?.user_email
          ? JSON.parse(res.data[0]?.user_email)
          : null;
        parsedEmailData && setParsedUserEmail(parsedEmailData);

        // parsed time zone
        const timezone = res.data[0]?.timezone
          ? JSON.parse(res.data[0]?.timezone)
          : null;
        timezone && setParsedTimezone(timezone);
      } else {
        setError("No company details found");
      }
    } catch (err) {
      setError(err.message || "Failed to fetch company details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!companyId) return;
    fetchCompanyDetails();
  }, [companyId, activeTab]);

  const handleClick = (event) => {
    setShows(!shows);
    setTargets(event.target);
  };

  // Helper functions to parse JSON data
  const parseUserPhone = (phoneData) => {
    try {
      if (typeof phoneData === "string") {
        const parsed = JSON.parse(phoneData);
        return Array.isArray(parsed) ? parsed[0] : parsed;
      }
      return phoneData;
    } catch {
      return null;
    }
  };

  const parseUserEmail = (emailData) => {
    try {
      if (typeof emailData === "string") {
        const parsed = JSON.parse(emailData);
        return Array.isArray(parsed) ? parsed[0] : parsed;
      }
      return emailData;
    } catch {
      return null;
    }
  };

  if (!companyGrants?.isView) {
    return (
      <div style={{ position: "absolute", left: "40%", top: "10rem" }}>
        <AuthorizationCard></AuthorizationCard>
      </div>
    );
  }

  if (!companyId) {
    return (
      <div className="d-flex w-100 align-items-center p-4 gap-3">
        <p className="mb-0">No company selected.</p>
        <button
          type="button"
          className="btn btn-default"
          onClick={handleCloseCompanyDetails}
        >
          Back to companies
        </button>
      </div>
    );
  }

  if (!companyData) {
    if (loading) {
      return <DetailsSkeleton />;
    }
    return null;
  }


  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      marginTop: '10px',
      minHeight: 38,
      fontSize: 13,
      padding: "0 4px",
      boxShadow: "none",
      border: state.isFocused ? "1px solid #2684FF" : "1px solid #d1d5db",
      "&:hover": {
        borderColor: "#60a5fa",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 4px",
    }),
    input: (base) => ({
      ...base,
      padding: "2px 0",
      margin: 0,
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: 13,
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: 13,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 34,
      padding: "0 3px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "4px",
    }),
    option: (base) => ({
      ...base,
      fontSize: 13,
      padding: "6px 10px",
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: 200,
      overflowY: "auto",
      scrollBehavior: "smooth",
      "::-webkit-scrollbar": {
        width: "8px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#c9c9c9",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#888",
      },
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#3b82f6",
      color: "white",
      fontSize: 12,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "white",
      fontWeight: 500,
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "white",
      ":hover": {
        backgroundColor: "#ef4444",
        color: "white",
      },
    }),
  };

  const userPhone = parseUserPhone(companyData[0].user_phone);
  const userEmail = parseUserEmail(companyData[0].user_email);
  const company_timezone = JSON.parse(companyData[0].timezone);

  const fetchWhatsappKey = async () => {
    setApiLoading((prev) => ({ ...prev, whatsapp: true }));
    setApiError((prev) => ({ ...prev, whatsapp: null }));

    try {
      const response = await GetRequest(
        `common/fetchWhatsappKey/${customerId}/company`,
        { headers },
        extras
      );

      if (response.status === "success") {
        setWhatsappKey(response.data);
        setWhatsAppModalOpen(true);
        // setShowMessageModal({ whatsapp: true, sms: false, email: false });
      } else {
        setShowIntegrationModal((prev) => ({ ...prev, whatsapp: true }));
        setIntegrationError((prev) => ({
          ...prev,
          whatsapp:
            "WhatsApp integration is not configured. Please set up WhatsApp Business API.",
        }));
      }
    } catch (error) {
      setShowIntegrationModal((prev) => ({ ...prev, whatsapp: true }));
      setIntegrationError((prev) => ({
        ...prev,
        whatsapp: "Failed to check WhatsApp integration. Please try again.",
      }));
    } finally {
      setApiLoading((prev) => ({ ...prev, whatsapp: false }));
    }
  };

  const fetchSmsKey = async () => {
    setApiLoading((prev) => ({ ...prev, sms: true }));
    setApiError((prev) => ({ ...prev, sms: null }));


    try {
      const response = await GetRequest(
        `common/fetchSmsKey/${customerId}/company`,
        { headers },
        extras
      );

      if (response.status === "success") {
        setSmsKey(response.data);
        setShowMessageModal({ whatsapp: false, sms: true, email: false });
      } else {
        setShowIntegrationModal((prev) => ({ ...prev, sms: true }));
        setIntegrationError((prev) => ({
          ...prev,
          sms: "SMS integration is not configured. Please set up SMS gateway.",
        }));
      }
    } catch (error) {
      setShowIntegrationModal((prev) => ({ ...prev, sms: true }));
      setIntegrationError((prev) => ({
        ...prev,
        sms: "Failed to check SMS integration. Please try again.",
      }));
    } finally {
      setApiLoading((prev) => ({ ...prev, sms: false }));
    }
  };

  const checkSmtpIntegration = async () => {
    setIntegrationLoading(true);
    setApiError((prev) => ({ ...prev, email: null }));

    try {
      const response = await GetRequest(
        `common/fetchSMTPDetails/${customerId}/company`,
        { headers },
        extras
      );

      if (response.status === "success" && response.data) {
        setSmtpDetails(response.data);
        fetchTemplates();
        setShowEmailModal(true);
      } else {
        setShowIntegrationModal((prev) => ({ ...prev, email: true }));
        setIntegrationError((prev) => ({
          ...prev,
          email:
            "Email integration is not configured. Please set up SMTP settings.",
        }));
      }
    } catch (error) {
      setShowIntegrationModal((prev) => ({ ...prev, email: true }));
      setIntegrationError((prev) => ({
        ...prev,
        email: "Failed to check email integration. Please try again.",
      }));
    } finally {
      setIntegrationLoading(false);
    }
  };
  const fetchSmtpDetails = async () => {
    setApiLoading((prev) => ({ ...prev, email: true }));

    try {
      const response = await GetRequest(
        `common/ fetchSMTPDetails / ${customerId} / company`,
        { headers },
        extras
      );

      // Modified condition to only check response.status
      if (response.status === "success") {
        setSmtpDetails(response.data); // Even if data is null
        setShowMessageModal({ whatsapp: false, sms: false, email: true });
      } else {
        setShowIntegrationModal({ whatsapp: false, sms: false, email: true });
      }
    } catch (error) {
      setShowIntegrationModal({ whatsapp: false, sms: false, email: true });
    } finally {
      setApiLoading((prev) => ({ ...prev, email: false }));
    }
  };

  const handleReassignTask = async () => {
    setShowReassignModal(true);

    const res = await GetRequest(
      `users/users/fetchUserAsOwner/${customer.customer_details.customer_id}`,
      { headers },
      { customer, setCustomer, rf: headers.authentication, navigate }
    );
    if (res?.status === "success") {
      // React Select format: { value, label }
      const options = res.data.map((user) => ({
        value: user.id,
        label: user.full_name,
      }));
      setUsers(options);
    }
  };

  const handleSubmit = async () => {
    const payload = {
      customer_id: customerId,
      owner_id: selectedUser.value,
      company_id: companyId,
    };

    const res = await PutRequest(
      `/company/reassign/
  `,
      payload,
      { headers },
      extras
    );
    if (res.status === "success") {
      toast.success(res.message);
      setShowReassignModal(false);
      fetchCompanyDetails();
    }
  };

  // for calling
  const handleGlobalCallChange = () => {
    setGlobalDiller(false);
  };

  const checkTwilio = async () => {
    if (isCheckingTwilio) return;
    setIsCheckingTwilio(true);
    try {
      const res = await checkTwilioIntegration(customerId, headers, extras)
      if (res.status === "fail" || res.success === false) {
        setShowTwilioModal(true);
      }
      if (res.status === "success") {
        setGlobalDiller(true);
      }

    } catch (error) {
      console.error(error)
    } finally {
      setIsCheckingTwilio(false);
    }
  }

  return (
    <>
      <div className="d-flex w-100" style={{ minWidth: 0 }}>
        {loading ? (
          <DetailsSkeleton />
        ) : (
          <div className="d-flex flex-column w-100" style={{ minWidth: 0 }}>
            <div
              className="d-flex align-items-center justify-content-between fs-13"
              style={{ cursor: "pointer", padding: "2px 0px 13px" }}
            >
              <div className="d-flex align-items-center gap-2">
                {companyIds.length > 0 && (
                  <>
                    <p
                      className="mb-0 btn-light btn d-flex align-items-center"
                      onClick={previousCompany}
                      style={
                        !prevCompanyId
                          ? {
                            pointerEvents: "none",
                            color: "#969696",
                            cursor: "no-drop",
                            height: "30px",
                            fontWeight: 300,
                            borderRadius: 2,
                            fontSize: 13,
                            border: "1px solid lightblue",
                          }
                          : {
                            cursor: "pointer",
                            height: "30px",
                            fontSize: "13px",
                            borderRadius: 2,
                            fontWeight: 300,
                            border: "1px solid lightblue",
                          }
                      }
                    >
                      <i className="me-1 bi bi-chevron-left" /> Prev
                    </p>

                    <p
                      className="mb-0 btn-light btn d-flex align-items-center"
                      onClick={nextCompany}
                      style={
                        !nextCompanyId
                          ? {
                            pointerEvents: "none",
                            color: "#969696",
                            cursor: "no-drop",
                            height: "30px",
                            fontWeight: 300,
                            borderRadius: 2,
                            fontSize: 13,
                            border: "1px solid lightblue",
                          }
                          : {
                            cursor: "pointer",
                            height: "30px",
                            fontSize: "13px",
                            borderRadius: 2,
                            fontWeight: 300,
                            border: "1px solid lightblue",
                          }
                      }
                    >
                      {" "}
                      Next <i className="ms-1 bi bi-chevron-right" />
                    </p>
                    <p
                      className="mb-0 mx-2 "
                      style={{ borderRight: "1px solid #c9c9c9", height: 29 }}
                    ></p>
                  </>
                )}
                <p
                  className="mb-0"
                  style={{
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    color: "black",
                    fontSize: "19px",
                    fontWeight: 300,
                  }}
                >
                  {" "}
                  Company Details{" "}
                </p>
              </div>
              <div>
                <div style={styles.headerActionsContainer}>
                  {/* whatsapp */}
                  <button
                    type="button"
                    className="btn btn-whatsapp p-2"
                    style={styles.headerActionButton}
                    onClick={fetchWhatsappKey}
                    disabled={apiLoading.whatsapp}
                  >
                    {apiLoading.whatsapp ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : integrationStatus.whatsapp === "success" ? (
                      <>
                        <FaWhatsapp style={{ fontSize: "13px" }} /> Configure
                      </>
                    ) : (
                      <>
                        {" "}
                        <FaWhatsapp
                          style={{ fontSize: "13px" }}
                        /> WhatsApp{" "}
                      </>
                    )}{" "}
                  </button>
                  {/* email */}
                  <button
                    type="button"
                    className="btn btn-default "
                    style={styles.headerActionButton}
                    onClick={() => {
                      // Pre-populate recipient if company has email
                      if (userEmail?.email) {
                        setEmailRecipients([userEmail.email]);
                      }
                      checkSmtpIntegration();
                    }}
                    disabled={integrationLoading}
                  >
                    {" "}
                    {integrationLoading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <>
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          style={styles.iconStyles}
                        />{" "}
                        Email{" "}
                      </>
                    )}
                  </button>
                  {/* call */}
                  <Dropdown className="dropdownsWithoutToggle">
                    <Dropdown.Toggle
                      variant="default"
                      style={styles.headerActionButton}
                      className="btn btn-default btnss"
                    >
                      <FontAwesomeIcon
                        icon={faPhone}
                        style={{
                          fontSize: "15px",
                          color: "#ffff",
                        }}
                      />
                      Call
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      align="end"
                      style={{
                        width: "8rem",
                        boxShadow: "0 0 15px #d7d7d7",
                        marginTop: "-22px",
                        marginRight: "25px",
                      }}
                    >
                      <Dropdown.Item
                        className="d-flex align-items-center btn"
                        style={{
                          fontSize: "12px",
                          padding: "4px 21px",
                        }}
                        disabled={isCheckingTwilio}
                        onClick={() => {
                          checkTwilio();
                        }}
                      >
                        {isCheckingTwilio ? (
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></span>
                        ) : (
                          "Call Now"
                        )}
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="d-flex align-items-center btn"
                        style={{
                          fontSize: "12px",
                          padding: "4px 21px",
                        }}
                        onClick={() => {
                          setCallLogOpen(true);
                        }}
                      >
                        Call log
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  {/* sms */}
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={fetchSmsKey}
                    style={styles.headerActionButton}
                  >
                    {" "}
                    {apiLoading.sms ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : integrationStatus.sms === "success" ? (
                      <>
                        <FontAwesomeIcon
                          icon={faMessage}
                          style={styles.iconStyles}
                        />
                        SMS
                      </>
                    ) : (
                      <>
                        {" "}
                        <FontAwesomeIcon
                          icon={faMessage}
                          style={styles.iconStyles}
                        />{" "}
                        SMS{" "}
                      </>
                    )}{" "}
                  </button>

                  <Dropdown className="dropdownsWithoutToggle">
                    <Dropdown.Toggle
                      style={styles.headerIconButton}
                      className="btn btn-default"
                    >
                      <FontAwesomeIcon icon={faEllipsisVertical} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => {
                        if (!companyGrants?.isEdit) {
                          toast.warning("You are not authorized for this action!")
                          return
                        }
                        handleReassignTask()
                      }}>
                        Reassign
                      </Dropdown.Item>
                      {showReassignModal && (
                        <Modal
                          show={showReassignModal}
                          onHide={handleReassingCancel}
                          backdrop="static"
                          keyboard={false}
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Reassign Task</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <p
                              style={{
                                color: "#787878",
                                fontSize: 13,
                                fontWeight: 200,
                                marginBottom: "30px",
                              }}
                            >
                              This task has been reassigned to a new owner.
                              They will manage all next steps and provide
                              updates going forward.
                            </p>
                            <Select
                              styles={customSelectStyles}
                              options={users}
                              value={selectedUser}
                              onChange={setSelectedUser}
                              placeholder="Select a user"
                              isSearchable
                              className="mb-4"
                            />

                            <div className="mb-3 d-flex justify-content-end gap-2">
                              <Button
                                variant="secondary"
                                onClick={handleReassingCancel}
                                className="btn btn-default-outline btn-sm"
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="default"
                                onClick={handleSubmit}
                                disabled={!selectedUser}
                                className="btn btn-default btn-sm"
                              >
                                Submit
                              </Button>
                            </div>
                          </Modal.Body>
                        </Modal>
                      )}

                      <Dropdown.Item onClick={() => {
                        if (!contactGrants?.isCreate) {
                          toast.warning("You are not authorized for this action!")
                          return
                        }
                        setContactCanvas(true)
                      }}>
                        Add Contact
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          if (!companyGrants?.isDelete) {
                            toast.warning("You are not authorized for this action!")
                            return
                          }
                          setConfirmDeleteId(companyId);
                        }}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <p
                    className="mb-0 mx-2 "
                    style={{ borderRight: "1px solid #c9c9c9", height: 29 }}
                  ></p>
                  <button
                    type="button"
                    className="btn btn-default "
                    style={styles.headerIconButton}
                    onClick={handleCloseCompanyDetails}
                  >
                    <FontAwesomeIcon icon={faXmark} className="ms-0" />
                  </button>
                </div>
              </div>
            </div>
            {confirmDeleteId && (
              <DeleteModal
                show={true}
                onConfirm={() => handleDeleteCompany(confirmDeleteId)}
                onClose={() => setConfirmDeleteId(null)}
                isLoading={loading}
                message={"Are you sure to permanent delete this company"}
              />
            )}
            <div
              className=" pt-4"
              style={{
                borderRadius: "8px",
                background: "#f9f9f9",
                height: "92%",
              }}
            >
              <Row className="ms-0 w-100 h-100 pe-2">
                {/* left side company details */}
                <LeftSideCompanyDetails
                  companyData={companyData}
                  companyId={companyId}
                  // currentCompanyId={allCompanies[nextPrevious]?.id}
                  contactDetails={contactDetails}
                  parsedUserEmail={parsedUserEmail}
                  parsedUserPhone={parsedUserPhone}
                  fetchCompanyDetails={fetchCompanyDetails}
                />

                {/* right side accordion */}
                <RightSideCompanyDetails
                  companyData={companyData}
                  companyId={companyId}
                />

              </Row>
            </div >
          </div>
        )}
        {/* Integration Error Modal (for failures) */}
        <Modal
          show={showMessageModal.sms}
          onHide={() =>
            setShowMessageModal((prev) => ({ ...prev, sms: false }))
          }
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Send SMS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label">Message</label>
              <textarea
                className="form-control"
                name="body"
                value={messageData.body}
                onChange={handleMessageInputChange}
                placeholder="Enter your message..."
                rows="5"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Notes (Optional)</label>
              <textarea
                className="form-control"
                name="notes"
                value={messageData.notes}
                onChange={handleMessageInputChange}
                placeholder="Add any notes..."
                rows="2"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-default-outline"
              onClick={() =>
                setShowMessageModal((prev) => ({ ...prev, sms: false }))
              }
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-default"
              onClick={() => handleSendMessage("sms")}
            >
              Send SMS
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showEmailModal}
          onHide={handleCloseEmailModal}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title className="d-flex justify-content-between align-items-center w-100">
              <span>Send Email</span>
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "14px", fontWeight: "normal" }}>
                  Choose Template:
                </span>
                <Dropdown>
                  <Dropdown.Toggle
                    variant="outline-primary"
                    size="sm"
                    disabled={templatesLoading}
                  >
                    {templatesLoading
                      ? "Loading..."
                      : selectedTemplate || "Select Template"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleTemplateSelect("", "")}>
                      No Template
                    </Dropdown.Item>
                    {templates.map((template) => (
                      <Dropdown.Item
                        key={template.id}
                        onClick={() =>
                          handleTemplateSelect(
                            template.id,
                            template.template_name
                          )
                        }
                      >
                        {template.template_name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* To Field with Tag Input */}
            <div className="mb-3">
              <label className="form-label">To</label>
              <div className="border rounded p-2" style={{ minHeight: "45px" }}>
                <div className="d-flex flex-wrap gap-1 align-items-center">
                  {emailRecipients.map((email, index) => (
                    <span
                      key={index}
                      className="badge bg-primary d-flex align-items-center gap-1"
                      style={{ fontSize: "12px" }}
                    >
                      {email}
                      <FontAwesomeIcon
                        icon={faTimes}
                        style={{ cursor: "pointer", fontSize: "10px" }}
                        onClick={() => removeEmailTag(email)}
                      />
                    </span>
                  ))}
                  <input
                    type="email"
                    className="border-0 flex-grow-1"
                    style={{ outline: "none", minWidth: "200px" }}
                    placeholder="Press ENTER to add email..."
                    value={currentEmailInput}
                    onChange={(e) => setCurrentEmailInput(e.target.value)}
                    onKeyDown={handleEmailInputKeyDown}
                    onBlur={addEmailTag}
                  />
                </div>
              </div>
            </div>

            {/* Subject Field */}
            <div className="mb-3">
              <label className="form-label">Subject</label>
              <input
                type="text"
                className="form-control"
                name="subject"
                value={messageData.subject}
                onChange={handleMessageInputChange}
                placeholder="Enter email subject"
              />
            </div>

            {/* Body Field with CKEditor */}
            <div className="mb-3">
              <label className="form-label fw-bold mb-2">Body</label>
              <div className="ckeditor-container">

                <ReactQuill
                  theme="snow"
                  value={messageData.body}
                  onChange={handleBodyChange}
                  placeholder="Write your message..."
                  style={{ minHeight: "160px" }}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, false] }],
                      ["bold", "italic", "underline", "link"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["blockquote", "code-block"],
                      ["clean"],
                    ],
                  }}
                />
              </div>
            </div>

            {/* Attachment Field */}
            <div className="mb-3">
              <label className="form-label">Attachment</label>
              <input
                type="file"
                className="form-control"
                onChange={handleFileChange}
                accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png"
              />
            </div>

            {/* Syntax Notes Table */}
            <div className="col-md-12 mt-4">
              <h3 className="h5 mb-2">Available Syntax</h3>
              <Table bordered size="sm">
                <thead>
                  <tr>
                    <th>SYNTAX</th>
                    <th>FIELD</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{"{{to_contact_name}}"}</td>
                    <td>Recipient Contact Name</td>
                  </tr>
                  <tr>
                    <td>{"{{to_company_name}}"}</td>
                    <td>Recipient Company Name</td>
                  </tr>
                  <tr>
                    <td>{"{{sender_name}}"}</td>
                    <td>Sender Name</td>
                  </tr>
                  <tr>
                    <td>{"{{sender_company_name}}"}</td>
                    <td>Sender Company Name</td>
                  </tr>
                  <tr>
                    <td>{"{{sender_number}}"}</td>
                    <td>Sender Phone Number</td>
                  </tr>
                  <tr>
                    <td>{"{{sender_email}}"}</td>
                    <td>Sender Email Address</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-default-outline"
              onClick={handleCloseEmailModal}
              disabled={emailSending}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-default"
              onClick={handleSendEmail}
              disabled={emailSending || emailRecipients.length === 0}
            >
              {emailSending ? "Sending..." : "Send Email"}
            </button>
          </Modal.Footer>
        </Modal>

        {/* Integration Error Modal */}
        <Modal
          show={
            showIntegrationModal.whatsapp ||
            showIntegrationModal.sms ||
            showIntegrationModal.email
          }
          onHide={() =>
            setShowIntegrationModal({
              whatsapp: false,
              sms: false,
              email: false,
            })
          }
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {showIntegrationModal.whatsapp && "WhatsApp Integration Required"}
              {showIntegrationModal.sms && "SMS Integration Required"}
              {showIntegrationModal.email && "Email Integration Required"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <div className="mb-3">
              {showIntegrationModal.whatsapp && (
                <i
                  className="fab fa-whatsapp text-success"
                  style={{ fontSize: "48px" }}
                ></i>
              )}
              {showIntegrationModal.sms && (
                <i
                  className="fas fa-sms text-info"
                  style={{ fontSize: "48px" }}
                ></i>
              )}
              {showIntegrationModal.email && (
                <i
                  className="fas fa-envelope text-primary"
                  style={{ fontSize: "48px" }}
                ></i>
              )}
            </div>
            {showIntegrationModal.whatsapp && (
              <>
                <h5>WhatsApp Integration Not Configured</h5>
                <p className="mb-3">
                  {integrationError.whatsapp ||
                    "WhatsApp Business API is not configured. Please contact your administrator."}
                </p>
              </>
            )}

            {showIntegrationModal.sms && (
              <>
                <h5>SMS Integration Not Configured</h5>
                <p className="mb-3">
                  {integrationError.sms ||
                    "SMS gateway is not configured. Please contact your administrator."}
                </p>
              </>
            )}

            {showIntegrationModal.email && (
              <>
                <h5>Email Integration Not Configured</h5>
                <p className="mb-3">
                  {integrationError.email ||
                    "SMTP settings are not configured. Please contact your administrator."}
                </p>
              </>
            )}

            <button
              className="btn btn-primary mb-2"
              onClick={() => {
                if (!extras?.navigate) return;

                const path =
                  integrationError.whatsapp || integrationError.sms
                    ? "/integration/msg91"
                    : integrationError.email
                      ? "/integration/email"
                      : null;

                if (path) extras.navigate(path);
                setShowIntegrationModal({
                  whatsapp: false,
                  sms: false,
                  email: false,
                });
              }}
            >
              Go to Integration Settings
            </button>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() =>
                setShowIntegrationModal({
                  whatsapp: false,
                  sms: false,
                  email: false,
                })
              }
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

      </div >
      {
        whatsappModalOpen && (
          <WhatsappModal
            whatsappModalOpen={whatsappModalOpen}
            setWhatsAppModalOpen={setWhatsAppModalOpen}
            id={companyId}
            module_name={"company"}
          />
        )
      }

      {/* {twilio modal} */}
      {
        showtwilioModal && (
          <TwilioIntegrationForm isOpen={showtwilioModal} onClose={() => setShowTwilioModal(false)} />
        )
      }
      {/* global */}
      {
        globalDiller && (
          <GlobalCallModal isOpen={globalDiller} customerId={customerId} loginUserId={customer?.customer_details?.id} phoneNumber={`${userPhone.country_code} ${userPhone.phone}`} onClose={handleGlobalCallChange} module_id={companyId} module_name={'company'} />
        )
      }
      {
        callLogOpen && (
          <DyanmicCallLog
            show={callLogOpen}
            onCloseModal={() => setCallLogOpen(false)}
            module_id={companyId}
            module_name={"company"}
          />
        )
      }

      {
        <ContactForm
          show={showContactCanvas}
          setShow={setContactCanvas}
          companyId={companyId}
          fetchCompanyDetails={fetchCompanyDetails}
          onClose={() => {
            setContactCanvas(false)
          }}
          indiviualHandlerFn={() => fetchCompanyDetails()}
          country={country}
          masterGrant={masterGrant}
        />
      }
    </>
  );
};
const styles = {
  iconStyles: {
    fontSize: 13,
    color: "#fff",
  },

  headerActionButton: {
    height: "30px",
    minWidth: "85px",
    padding: "0 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    borderRadius: "2px",
    fontSize: "13px",
  },

  headerIconButton: {
    height: "30px",
    width: "30px",
    minWidth: "30px",
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
    fontSize: "13px",
  },

  headerActionsContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
};